import React from "react";
import "@mobiscroll/react/dist/css/mobiscroll.min.css";
import { Datepicker, Input, Page } from "@mobiscroll/react";
import { useEffect } from "react";
import Moment from "moment";
import ReservationService from "../../services/ReservationService";

// Helper to get weekday string from date
function getWeekdayStr(date) {
  const days = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
  return days[new Date(date).getDay()];
}

function DatePickerFile(props) {
  // const now = new Date();
  const today = Moment(new Date()).format("YYYY-MM-DD");
  const [start, setStart] = React.useState(props.startDate);
  const [end, setEnd] = React.useState(props.endDate);
  const [listingSlug, setListingSlug] = React.useState(props.listingSlug);
  const [validationMsg, setValidationMsg] = React.useState("");
  const [weekdayRules, setWeekdayRules] = React.useState({});
  const [lorTotalRec, setlorTotalRec] = React.useState(0);
  const [lorRecord, setlorRecord] = React.useState([]);
  const setDates = (date) => {
    setValidationMsg("");
    let startDate = date.value[0] ? Moment(date.value[0]) : null;
    let endDate = date.value[1] ? Moment(date.value[1]) : null;
    let error = "";

    // Helper for weekday validation
    const isCheckAllowed = (dateMoment, type) => {
      if (!dateMoment) return true;
      const day = getWeekdayStr(dateMoment);
      return weekdayRules[day] ? !!weekdayRules[day][type] : true;
    };

    // Weekday validation
    if (startDate && !isCheckAllowed(startDate, "checkin")) {
        error = `Check-in is not allowed on ${startDate.format("dddd")}.`;
      }
    if (!error && endDate && !isCheckAllowed(endDate, "checkout")) {
        error = `Check-out is not allowed on ${endDate.format("dddd")}.`;
    }

    // Min/Max Stay validation
    if (!error && startDate && endDate) {
      const nights = endDate.diff(startDate, "days");
      if (nights <= 0) {
        error = "Checkout date must be after check-in date.";
      } else {
        // 1) Try to find the rule that CONTAINS the check-in date (inclusive)
        let appliedRule = null;
        for (const rule of lorRecord) {
          const ruleStart = Moment(rule.from_date).startOf("day");
          const ruleEnd = Moment(rule.to_date).endOf("day");
          if (
            startDate.isSameOrAfter(ruleStart, "day") &&
            startDate.isSameOrBefore(ruleEnd, "day")
          ) {
            appliedRule = rule;
            break;
          }
        }

        // 2) If no rule contains check-in, fallback to first overlapping rule (inclusive)
        if (!appliedRule) {
          for (const rule of lorRecord) {
            const ruleStart = Moment(rule.from_date);
            const ruleEnd = Moment(rule.to_date);
            // inclusive overlap check: checkin < ruleEnd+1day AND checkout > ruleStart
            if (
              startDate.isBefore(ruleEnd.clone().add(1, "day")) &&
              endDate.isAfter(ruleStart)
            ) {
              appliedRule = rule;
              break;
            }
          }
        }

        // 3) Validate using the applied rule (if any)
        if (appliedRule) {
          const ruleStart = Moment(appliedRule.from_date);
          const ruleEnd = Moment(appliedRule.to_date);
          const minStay = appliedRule.stays_from;
          const maxStay = appliedRule.stays_upto;
          const restrictionType = appliedRule.restriction_type;

          if (restrictionType === 1) {
            // validate ONLY the overlapping portion for this rule
            const overlapStart = Moment.max(startDate, ruleStart);
            const overlapEnd = Moment.min(
              endDate,
              ruleEnd.clone().add(1, "day")
            );
            const overlapNights = overlapEnd.diff(overlapStart, "days");

            if (minStay && overlapNights < minStay) {
              error = `Minimum stay is ${minStay} nights.`;
            } else if (maxStay && overlapNights > maxStay) {
              error = `Maximum stay is ${maxStay} nights.`;
            }
          } else {
            // validate using total nights for the applied rule
            if (minStay && nights < minStay) {
              error = `Minimum stay is ${minStay} nights.`;
            } else if (maxStay && nights > maxStay) {
              error = `Maximum stay is ${maxStay} nights.`;
            }
          }
        }
        // if no rule applied — we do nothing (no min/max validation)
      }
    }

    if (error) {
      setValidationMsg(error);
      date.value = [null, null];
    }

    props.changeDateHandlerNew(date);
  };

  localStorage.removeItem("checkin");
  localStorage.removeItem("checkout");

  // Example effect using props
  useEffect(() => {
    setListingSlug(props.listingSlug);
    getWeekdayRules();
    getLorData();
    // eslint-disable-next-line
  }, [props.listingSlug]);

  async function getWeekdayRules() {
    try {
      const dayMap = {
        Monday: "MO",
        Tuesday: "TU",
        Wednesday: "WE",
        Thursday: "TH",
        Friday: "FR",
        Saturday: "SA",
        Sunday: "SU",
      };
      let res = await ReservationService.getListingAvailabilityRule(
        "listing_slug=" + props.listingSlug
      );

      if (global.successStatus.includes(res.status)) {
        if (res.data && res.data.length > 0) {
          const rules = res.data.reduce((acc, rule) => {
            const code = dayMap[rule.day_name];
            acc[code] = {
              checkin: rule.checkin_never_on ? 0 : 1,
              checkout: rule.checkout_never_on ? 0 : 1,
            };
            return acc;
          }, {});
          setWeekdayRules(rules);
        }
      }
    } catch (error) {
      console.error("Error fetching availability", error);
    }
  }

  async function getLorData() {
    var lorList = [];
    var lorTotalRecords = 0;

    let res = await ReservationService.getListingLOR(
      "listing_slug=" + props.listingSlug
    );

    if (global.successStatus.includes(res.status)) {
      lorList = res.data ? res.data : [];

      lorTotalRecords = lorList.length ? lorList.length : 0;
    }
    setlorTotalRec(lorTotalRecords);
    setlorRecord(lorList);
  }

  return (
    <Page>
      <div className="mbsc-grid mbsc-no-padding">
        {validationMsg && (
          <div style={{ color: "red", marginBottom: 8 }}>{validationMsg}</div>
        )}
        <div className="mbsc-row mobiscrollCalendar ">
          <div className="mbsc-col-6 ">
            <Datepicker
              controls={["calendar"]}
              select="range"
              startInput={start}
              endInput={end}
              defaultValue={[props.startDate, props.endDate]}
              valid={props.availableDate}
              min={today}
              pages={2}
              onChange={setDates}
              id={"calender-end-open"}
              touchUi={props.touchUi ? true : false}
              theme="ios"
              buttons={props.buttons ? props.buttons : []}
              inputTyping={false}
              themeVariant="light"
              cssClass="str_dual_calendar"
              minRange={2}
              inRangeInvalid={false}
              rangeEndInvalid={true}
              responsive={{
                xsmall: {
                  calendarScroll: "vertical",
                  calendarSize: "2",
                },
                medium: {},
              }}
            />
            <Input
              ref={setStart}
              value={
                props.startDate
                  ? Moment(props.startDate).local().format("MM/DD/YYYY")
                  : ""
              }
              id={"calender-start-open"}
              label="Check-in"
              inputStyle=""
              labelStyle="stacked"
              placeholder="Add date"
              className="str_detail_cal"
            >
              Check-in{" "}
            </Input>
          </div>
          <div className="mbsc-col-6">
            <Input
              ref={setEnd}
              value={
                props.endDate
                  ? Moment(props.endDate).local().format("MM/DD/YYYY")
                  : ""
              }
              id={"calender-end-open1"}
              label="Check-out"
              inputStyle=""
              labelStyle="stacked"
              placeholder="Add date"
            >
              Check-out
            </Input>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default DatePickerFile;
